import { render, staticRenderFns } from "./GroupCard.vue?vue&type=template&id=f5f52fd4"
import script from "./GroupCard.vue?vue&type=script&lang=ts"
export * from "./GroupCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5f52fd4')) {
      api.createRecord('f5f52fd4', component.options)
    } else {
      api.reload('f5f52fd4', component.options)
    }
    module.hot.accept("./GroupCard.vue?vue&type=template&id=f5f52fd4", function () {
      api.rerender('f5f52fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/teams/GroupCard.vue"
export default component.exports